module.exports = __webpack_public_path__ + "static/media/cylinder_cover_lightblue.2777b66d.png";